
import CryptoJS from "crypto-js";

// This should be 32 characters long (256-bit key for AES-256)
const ENCRYPTION_SECRET = process.env.REACT_APP_ENCRYPTION_SECRET;

if (!ENCRYPTION_SECRET || ENCRYPTION_SECRET.length !== 32) {
  throw new Error("REACT_APP_ENCRYPTION_SECRET must be 32 characters long.");
}

/**
 * Encrypt text using AES-256-CBC compatible with backend decryption
 * @param {string} text - Plaintext to encrypt
 * @returns {string} Encrypted string in iv:encrypted format
 */
export function encrypt(text) {
  const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_SECRET);
  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return iv.toString(CryptoJS.enc.Hex) + ':' + encrypted.toString();
}

/**
 * Optional decrypt method (for frontend testing only)
 */
export function decrypt(encryptedText) {
  const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_SECRET);
  const [ivHex, encrypted] = encryptedText.split(':');
  const iv = CryptoJS.enc.Hex.parse(ivHex);

  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}
